// extracted by mini-css-extract-plugin
module.exports = {"filelist":"filelist___PSNp5","back":"back___Wkeva"};